import React from 'react';
import { addClassNames } from '../../../Functions/Helper/Component';
import { stripHtml } from '../../../Functions/Helper/RichText';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import './RichTextInput.scss';

function getHtmlCharCount(html) {
    return stripHtml(html || "").length || 0;
}

export default function RichTextInput({ 
    label, children, 
    maxCharacterCount,inputClassName,
    className, disabled,
    value, disabledValue,
    onChange, labelClassName, ...rest
}) {
    const [focused, setFocused] = React.useState(false);
    const reactQuillRef = React.useRef(null);
    const charCount = React.useMemo(() => {
        
        if (disabled && disabledValue) {
            return getHtmlCharCount(disabledValue);
        }
        return getHtmlCharCount(value);
    }, [value, disabled, disabledValue]);
    
    React.useEffect(() => {
        if (!reactQuillRef?.current) return;
        const quill = reactQuillRef.current.getEditor();
        const handler = () => {
            if (!maxCharacterCount) return;
            const textLength = quill.getText().length;
            if (textLength <= maxCharacterCount) return;
            quill.updateContents([{ retain: maxCharacterCount - 1 }, { delete: textLength - maxCharacterCount }]);
        };
        quill.on('text-change', handler);
        return () => { quill.off('text-change', handler); };
    }, [maxCharacterCount]);
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            const qlToolbars = document.getElementsByClassName("ql-toolbar");
            for(var toolbarC = 0; toolbarC < qlToolbars.length; toolbarC++) {
                const toolbar = qlToolbars[toolbarC];
            
                toolbar.setAttribute("tabindex", "-1");
                const buttons = toolbar.getElementsByTagName("button");
                for (var c = 0; c < buttons.length; c++) {
                    const button = buttons[c];
                    button.setAttribute("tabindex", "-1");
                }
    
                const select = toolbar.getElementsByClassName("ql-picker-label")[0];
                if (select) {
                    select.setAttribute("tabindex", "-1");
                }
            }
        }, 100);
        return () => clearTimeout(timeout);
    }, []);

    const _onChange = React.useCallback((v) => {
        if (v === "<p><br></p>") v = "";
        if (onChange) onChange(v);
    }, [onChange]);

    return (
        <div className={addClassNames("input", (className || ""))}>
            <label className={labelClassName} htmlFor={rest?.id}>{children || label}</label>
            <div className={addClassNames("input-group", (focused? " focus" : ""))} >
                <ReactQuill
                    ref={reactQuillRef}
                    disabled={disabled}
                    onChange={_onChange}
                    onFocus={()=>setFocused(true)}
                    onBlur={()=>setFocused(false)}
                    className={addClassNames("rich-text-input bg-white", inputClassName)}
                    value={(disabled? disabledValue : value) || ""}
                />
                {maxCharacterCount && (
                    <div
                        className="character-count rounded-pill"
                        style={{
                            backgroundColor: `var(--mo-${charCount >= maxCharacterCount ? "danger" : "primary"})`
                        }}
                    >
                        {charCount}
                    </div>
                )}
            </div>
        </div>
    );
}